var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-image-wrapper",
      style: { backgroundColor: _vm.bgColor },
    },
    [
      _c("img", { staticStyle: { display: "none" }, attrs: { src: _vm.src } }),
      _vm._v(" "),
      _vm.parallax
        ? _c(
            "parallax",
            {
              attrs: {
                speedFactor: _vm.parallax.speedFactor,
                direction: _vm.parallax.direction,
                fixed: _vm.parallax.fixed,
                sectionHeight: _vm.parallax.sectionHeight,
                breakpoint: _vm.parallax.breakpoint,
                sectionClass: _vm.parallax.sectionClass,
                containerClass: _vm.parallax.containerClass,
                parallaxClass: _vm.parallax.parallaxClass,
                fixedClass: _vm.parallax.fixedClass,
              },
            },
            [
              _c("div", {
                staticClass: "bg-image",
                class: {
                  "image-loaded": _vm.loaded,
                  "blur-effect": _vm.blur,
                  "opacity-effect": _vm.effect === "opacity",
                },
                style: { backgroundImage: "url(" + _vm.imageSrc + ")" },
              }),
            ]
          )
        : [
            _c("div", {
              staticClass: "bg-image",
              class: {
                "image-loaded": _vm.loaded,
                "blur-effect": _vm.blur,
                "opacity-effect": _vm.effect === "opacity",
              },
              style: { backgroundImage: "url(" + _vm.imageSrc + ")" },
              on: {
                click: function ($event) {
                  return _vm.onClickedChild(_vm.src)
                },
              },
            }),
          ],
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/components/bg-image/bg-image.vue